import { jsx as _jsx } from "react/jsx-runtime";
import { useProductTileContext } from '@as/cotopaxi';
import { Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { getAvailableSizes } from '../../../../util/ProductUtil';
const SIZES_MAX = 5;
const SIZE_ROW_LENGTH = 20;
const getSizeDescription = (size) => size.fullCommercialSize || size.commercialSizeDefault || size.code;
export const ProductTileSizesInfo = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { activeColorId, colors } = useProductTileContext();
    const activeColour = colors.find(color => color.colourId === activeColorId);
    const { sizes = [] } = activeColour;
    const filteredSizes = getAvailableSizes(sizes);
    if (filteredSizes.length > SIZES_MAX ||
        filteredSizes.map(size => getSizeDescription(size)).join('').length > SIZE_ROW_LENGTH) {
        return (_jsx(TextAlpha, { as: "span", variant: "bodyS", color: "subtle", lineClamp: 1, children: t('product.multi.sizes') }));
    }
    return (_jsx(Stack, { gap: "5", children: filteredSizes.map(size => (_jsx(TextAlpha, { as: "span", variant: "bodyS", color: "subtle", children: getSizeDescription(size) }, size.sku))) }));
};
